import { Node, mergeAttributes } from "@tiptap/core";

export const TiktokServerside = Node.create({
  name: "tiktok",

  group: "block",
  content: "inline*",

  parseHTML() {
    return [
      {
        tag: 'a[data-type="tiktok"]',
      },
    ];
  },
  addAttributes() {
    return {
      url: { default: null },
      "data-id": { default: null },
      class: { default: "inline-tiktok" },
    };
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "tiktok",
        class: `react-renderer node-tiktok ${HTMLAttributes.class}`,
      }),
      0,
    ];
  },
});
